<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Welcome back</small>
                                <base-alert :type="successAlertType" v-if="successAlertVisible">
                                    {{successAlertText}}
                                </base-alert>
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Email Address"
                                            name="emailAddress"
                                            v-model="input.emailAddress"
                                            addon-left-icon="ni ni-emailAddress-83">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            name="password"
                                            v-model="input.password"
                                            placeholder="Password"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <base-checkbox>
                                    Remember me
                                </base-checkbox>
                                <div class="text-center">
                                    <base-button type="primary"
                                                 class="my-4"
                                                 v-on:click="login">Sign In</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <div class="row mt-3">
                        <div class="col-6">
                            <a href="#" class="text-light">
                                <small>Forgot password?</small>
                            </a>
                        </div>
                        <div class="col-6 text-right">
                            <a href="#" class="text-light">
                                <small>Create new account</small>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Login',
        data() {
            return {
                input: {
                    emailAddress: "",
                    password: ""
                },
                successAlertVisible: false,
                successAlertText: "",
                successAlertType: "success",
            }
        },
        methods: {
            login() {
                if(this.input.emailAddress != "" && this.input.password != "") {
                   
                    var bodyData = JSON.stringify(this.input);
                    console.log(bodyData);
                    this.$http.post(`/auth`,bodyData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        if (response.status == 200)
                        {
                            localStorage.clear();
                            localStorage.token = response.data.token
                            
                            this.$currentUser.userId = response.data.person.id;
                            this.$currentUser.accountGroup = response.data.person.owningAccount.id;

                            this.$router.replace(this.$route.query.redirect || '/secure')
                        }
                        else
                        {
                            //this.successAlert.type = "Danger";
                            this.successAlertText = "We don't recognise your credentials!"
                            this.successAlertType = "danger";
                            this.successAlertVisible = true;
                            
                        }

                    })
                    .catch(e => {
                        this.successAlertText = "We don't recognise your credentials!";
                        this.successAlertType = "danger";
                        this.successAlertVisible = true;
                    })

                } else {
                    console.log("A username and password must be present");
                }
            }
        }


};
</script>
<style>
</style>
